import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { DigitalMediaList } from './templates/DigitalMediaList/DigitalMediaList';
import * as Styled from './DigitalMedia.style';
// --- MOCKS ESPECÍFICOS DO DIGITAL MEDIA LIST ---
const mockTabs = [
    { label: 'TODOS', value: 'todos' },
    { label: 'DESTAQUES', value: 'destaques' },
    { label: 'FAVORITOS', value: 'favoritos' },
];
const mockFilterSections = [
    {
        id: 'category',
        label: 'Categoria',
        options: [
            { id: 'cat1', label: 'E-book', value: 'ebook', checked: false },
            { id: 'cat2', label: 'Jogo', value: 'jogo', checked: true },
            { id: 'cat3', label: 'Vídeo', value: 'video', checked: false },
        ],
    },
    {
        id: 'topic',
        label: 'Tópico',
        options: [
            { id: 'top1', label: 'Inovação', value: 'inovacao', checked: false },
            { id: 'top2', label: 'Marketing', value: 'marketing', checked: false },
            { id: 'top3', label: 'Finanças', value: 'financas', checked: false },
        ],
    }
];
const mockMidiaCards = [
    {
        id: 'card-1',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=dc75e08b_d366_4e7e_be06_aafd8707da3d.png?_v638974988705625228',
        tag: 'FINANÇAS',
        type: 'Jogo',
        title: 'Legado: Sucessão Familiar',
        views: 2026,
        comments: 37,
        link: '#',
    },
    {
        id: 'card-2',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=5f191944_0968_48e5_a01e_9cfd0718bed4.jpeg',
        tag: 'EMPREENDEDORISMO',
        type: 'Jogo',
        title: 'Negócio de Outro Planeta',
        views: 2026,
        comments: 37,
        link: '#',
    },
    {
        id: 'card-3',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=172b8d53_dbad_4291_afe0_18e030f5e06a.jpeg',
        tag: 'EMPREENDEDORISMO',
        type: 'Jogo',
        title: 'Pizza Delivery',
        views: 2026,
        comments: 37,
        link: '#',
    },
    {
        id: 'card-4',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=b5391dc5_3f26_4396_bd05_4f20eda49039.jpeg',
        tag: 'EMPREENDEDORISMO',
        type: 'Jogo',
        title: 'Saga do Herói',
        views: 2026,
        comments: 37,
        link: '#',
    },
    {
        id: 'card-5',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=e89b8fa8_da39_4624_8d60_5c19168ce62c.jpeg',
        tag: 'EMPREENDEDORISMO',
        type: 'Jogo',
        title: 'Barbaridade',
        views: 2026,
        comments: 37,
        link: '#',
    },
    {
        id: 'card-6',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=ea09d127_8580_4b12_ace3_27d789ddb13a.jpeg',
        tag: 'EMPREENDEDORISMO',
        type: 'Jogo',
        title: 'Fazendinha de Negócios',
        views: 2026,
        comments: 37,
        link: '#',
    },
    {
        id: 'card-7',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=8a37633d_83f4_4656_9d85_afa3a94b4de7.jpeg',
        tag: 'EMPREENDEDORISMO',
        type: 'Jogo',
        title: 'Ideia e Ação',
        views: 2026,
        comments: 37,
        link: '#',
    },
    {
        id: 'card-8',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=4d78ae86_ba30_4f7f_8984_e696514f6208.jpeg',
        tag: 'EMPREENDEDORISMO',
        type: 'Jogo',
        title: 'Sr. Ciclo - Bike Shop',
        views: 2026,
        comments: 37,
        link: '#',
    },
    {
        id: 'card-9',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=fa85c19c_adaa_4cf5_a270_3555cda31691.jpeg',
        tag: 'EMPREENDEDORISMO',
        type: 'Jogo',
        title: 'Cidade dos Brinquedos',
        views: 2026,
        comments: 37,
        link: '#',
    },
    {
        id: 'card-10',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=fae432ac_3330_4ba2_b981_1dc1c54f6d18.jpeg',
        tag: 'EMPREENDEDORISMO',
        type: 'Jogo',
        title: 'Fábrica de Chocolate',
        views: 2026,
        comments: 37,
        link: '#',
    },
    {
        id: 'card-11',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=3fa298bd_3d84_49ef_92b7_13809b2cb7f1.jpeg',
        tag: 'EMPREENDEDORISMO',
        type: 'Jogo',
        title: 'Copo com Saúde',
        views: 2026,
        comments: 37,
        link: '#',
    },
    {
        id: 'card-12',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=86118065_b204_4379_b2de_252be15ea40b.jpeg',
        tag: 'EMPREENDEDORISMO',
        type: 'Jogo',
        title: 'Nem parece jogo de Pizzaria',
        views: 2026,
        comments: 37,
        link: '#',
    },
    {
        id: 'card-13',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=ec77bf4c_b60b_4fe5_b5ff_1c8df00e333d.png?_v638966383377907439',
        tag: 'EMPREENDEDORISMO',
        type: 'Jogo',
        title: 'TYCOON: Empreendedorismo para pessoas com Síndrome de Down',
        views: 2026,
        comments: 37,
        link: '#',
    },
    {
        id: 'card-14',
        imageSrc: 'https://eadlms.sebrae.com.br/api/main/avanovo/core/image?module=media&folder=thumbnails&fileName=2434452c_08d9_4c7a_8613_d233a10131d9.jpeg',
        tag: 'EMPREENDEDORISMO',
        type: 'Jogo',
        title: 'Cidade Colaborativa',
        views: 2026,
        comments: 37,
        link: '#',
    },
];
// --- COMPONENTE DE PÁGINA ---
export const DigitalMediaPage = () => {
    const [selectedTab, setSelectedTab] = useState('todos');
    const [filters, setFilters] = useState(mockFilterSections);
    const handleTabChange = (tab) => {
        console.log('Aba alterada:', tab);
        setSelectedTab(tab);
    };
    const handleFilterChange = (sectionId, value, checked) => {
        console.log('Filtro alterado:', { sectionId, value, checked });
        setFilters(prevFilters => prevFilters.map(section => {
            if (section.id === sectionId) {
                return Object.assign(Object.assign({}, section), { options: section.options.map(opt => opt.value === value ? Object.assign(Object.assign({}, opt), { checked }) : opt) });
            }
            return section;
        }));
    };
    const handleRemoveFilter = (sectionId, value) => {
        console.log('Removendo filtro:', { sectionId, value });
        handleFilterChange(sectionId, value, false);
    };
    const handleClearFilters = () => {
        console.log('Limpando todos os filtros');
        setFilters(prevFilters => prevFilters.map(section => (Object.assign(Object.assign({}, section), { options: section.options.map(opt => (Object.assign(Object.assign({}, opt), { checked: false }))) }))));
    };
    return (_jsx(Styled.Fragment, { children: _jsx(DigitalMediaList, { tabs: mockTabs, midiaCards: mockMidiaCards, filterSections: filters, selectedTab: selectedTab, onTabChange: handleTabChange, onFilterChange: handleFilterChange, onRemoveFilter: handleRemoveFilter, onClearFilters: handleClearFilters, totalItems: 100, itemsPerPage: 10, inverse: false }) }));
};
//# sourceMappingURL=DigitalMedia.js.map